module.exports = __webpack_public_path__ + "static/media/checkBlue.414c19d4.svg";